export const modals = {
    en: {
        are_you_sure: 'Are you sure you want',
        restart_game: 'to restart the game?',
        yes_restart: 'Yes, restart the game',
        progress_will_lost: 'All current game progress will be lost',
        pick_up_the_move: 'pick up the tryMove?',
        not_your_turn: 'Now it’s not your turn',
        yes_pick_up: 'Yes, pick up',
        start_new_round: 'start a new round?',
        still_going: 'This is still in going',
        next_go: 'Let the next to go',
        no_cancel: 'No, cancel',
        yes_start_new: 'Yes, start new',
        delete_card: 'delete card?',
        yes_delete: 'Yes, delete',
        no_delete: 'No, don’t delete',
        open: 'open',
        by_rules_no_see: 'By the rules you can’t see it',
        yes_open: 'Yes, open',
        continue_game: 'continue game',
        player_viewing_catalog: 'One of the players is still browsing the catalog',
        continue: 'Continue',
        upload_large_files: 'upload large/heavy files?',
        warning_download_heavy_files: 'Some of your images are over 1MB and are over 200*300 px. They will slow down the system while playing',
        download_anyway: 'Download anyway',
        you_use: 'You are using',
        browser_recommendations: 'We recommend using the Chrome browser, otherwise it may not work correctly',
        connection_problem: 'Connection problem',
        press_to_reconnect: 'Press to reconnect',
        u_have_new_player: 'You have a new player',
        player_left: 'One of players left',
        restart_game_suggest: 'Do you want to start a new game?',
    },
    ru: {
        are_you_sure: 'Вы уверены, что хотите',
        restart_game: 'начать игру заново?',
        yes_restart: 'Да, начать игру заново',
        progress_will_lost: 'Текущие результаты не сохранятся',
        pick_up_the_move: 'забрать ход?',
        not_your_turn: 'Сейчас не ваша очередь',
        yes_pick_up: 'Да, забрать',
        start_new_round: 'начать новый раунд?',
        still_going: 'Этот еще идет',
        next_go: 'Пусть ходит следующий',
        no_cancel: 'Нет, отменить',
        yes_start_new: 'Да, начать новый',
        delete_card: 'удалить карту?',
        yes_delete: 'Да, удалить',
        no_delete: 'Нет, не удалять',
        open: 'открыть',
        by_rules_no_see: 'По правилам вам нельзя это видеть',
        yes_open: 'Да, открыть',
        continue_game: 'продолжить игру?',
        player_viewing_catalog: 'Один из игроков все еще просматривает каталог',
        continue: 'Продолжить',
        upload_large_files: 'загрузить большие/тяжелые файлы?',
        warning_download_heavy_files: 'Некоторые из ваших изображений весят более 1МБ и имеют размер более' +
            ' 200*300 px. Они будут тормозить систему во время игры',
        download_anyway: 'Все равно загрузить',
        you_use: 'Вы используете',
        browser_recommendations: 'Мы рекомендуем использовать браузер Chrome, иначе работа может быть некорректной',
        connection_problem: 'Соединение закрыто',
        press_to_reconnect: 'Подключиться повторно',
        u_have_new_player: 'У вас новый игрок',
        player_left: 'Один из игроков вышел',
        restart_game_suggest: 'Хотите начать новую игру?',
    }
};
